import { Locale } from "@borealis/aurora";
import { NMPLocale } from "@borealis/locale-common";
import { formatNumber } from "@borealis/number-format";

export function largeNumberFormatter(value: number | string, locale: Locale) {
    if (value === "") {
        return value;
    }

    const intValue = typeof value === "string" ? parseInt(value, 10) : value;

    return formatNumber(intValue, locale as NMPLocale);
}
